import { Injectable } from '@angular/core';
import { ToastrFactoryService } from '../services/toastr-factory.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ClipboardService {
  constructor(
    private toastrFactory: ToastrFactoryService,
    private translate: TranslateService,
  ) {}

  copyToClipboard(data: string | number | undefined, customToastrText?: string): void {
    if (!data) {
      this.toastrFactory.error('nothingToBeCopied');
      return;
    }
    navigator.clipboard.writeText(data.toString()).then(() => {
      this.toastrFactory.success(this.translate.instant(customToastrText || 'sucessfullyCopiedToClipboard'));
    });
  }
}
